import React from 'react'
import { Text, View } from 'react-native'

import { useQuoteData } from '@flows-ui/services/QuoteDataContext'
import { useTranslation } from '@flows-ui/utils/i18n'
import { processStepContentElementText } from '@flows-ui/utils/processStepContentElementText'
import type { TextContent } from '@flows/core/i18n/types'
import { h3, h4 } from '@ui-kit/core/typography'

type Props = {
  productName: string
  headerTitle?: TextContent
  headerSubtitle?: TextContent
}

export const QuoteHeader = (props: Props) => {
  const { t } = useTranslation()
  const { flowValues } = useQuoteData()
  const translateFunction = processStepContentElementText(t, {
    flowValues,
    servicesResponses: {},
  })

  const titleText = props.headerTitle
    ? translateFunction(props.headerTitle)
    : t('sharedFlows_common:steps.quote.header.title', {
        productName: props.productName.toUpperCase(),
      })

  return (
    <View className="items-center gap-y-1">
      <Text className={h3({ type: 'primary', align: 'center' })}>{titleText}</Text>
      {props.headerSubtitle && (
        <Text className={h4({ align: 'center' })}>{translateFunction(props.headerSubtitle)}</Text>
      )}
    </View>
  )
}
